export default "__VITE_ASSET__0hmArpwU__"